import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  xBand,
  backgroundColor,
  discreteLegend,
  color,
  initPivot,
  datasetPivot,
  pivotDiscreteLegend,
  pivotIndicators,
  pivotAdapter,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  annotationVerticalLine,
  annotationHorizontalLine,
  pointStyle,
  lineStyle,
  pointStateDimensionHover,
  progressive,
  areaStyle,
  columnStyle,
  verticalCrosshairRect,
  yLinearSecondary,
  yLinearPrimary,
  seriesDualAxis,
  series,
  colorBarStyleFill,
  colorPointStyleFill,
  colorLineStyleFill,
  colorAreaStyleFill,
  linearColor,
  colorAdapter,
  colorLegend,
  pivotColorLegend,
  linearColorForDualAxis,
  annotationAreaBand,
  barMaxWidth,
  barGapInGroup,
  barCornerRadius,
  pivotTitle,
  pivotAxisStyle,
  dimensionLinkage,
  annotationPointOfDualAxis,
  barStyleFilter,
  pointStyleFilter,
  lineStyleFilter,
  areaStyleFilter,
  tooltipDualAxis,
  initDualAxis,
  dualChartType,
  datasetDualAxis,
  labelDualAxis,
  tooltipOfDualAxisSeries,
  adjustXField,
  fontFamilyTheme,
} from '../pipes'

const dualAxis: VChartSpecPipeline = [
  fontFamilyTheme,
  seriesDualAxis(
    [initDualAxis, dualChartType, datasetDualAxis, labelDualAxis, tooltipOfDualAxisSeries],

    [
      animationMorph,
      progressive,

      barMaxWidth,
      barGapInGroup,
      barStyleFilter(barCornerRadius),

      barStyleFilter(colorBarStyleFill(columnStyle)),
      pointStyleFilter(colorPointStyleFill(pointStyle)),
      pointStyleFilter(pointStateDimensionHover),
      lineStyleFilter(colorLineStyleFill(lineStyle)),
      areaStyleFilter(colorAreaStyleFill(areaStyle)),
    ],
  ),
  adjustXField,
  xBand,
  yLinearPrimary,
  yLinearSecondary,

  colorAdapter(color, linearColorForDualAxis),
  colorAdapter(discreteLegend, colorLegend),

  backgroundColor,

  verticalCrosshairRect,
  annotationPointOfDualAxis,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,

  tooltipDualAxis,
]

const pivotDualAxis: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    series(
      [initDualAxis, dualChartType, datasetDualAxis, labelDualAxis, tooltipOfDualAxisSeries],

      [
        animationMorph,
        progressive,

        barMaxWidth,
        barGapInGroup,
        barStyleFilter(barCornerRadius),

        barStyleFilter(colorBarStyleFill(columnStyle)),
        pointStyleFilter(colorPointStyleFill(pointStyle)),
        pointStyleFilter(pointStateDimensionHover),
        lineStyleFilter(colorLineStyleFill(lineStyle)),
        areaStyleFilter(colorAreaStyleFill(areaStyle)),
      ],
    ),
    adjustXField,
    xBand,
    yLinearPrimary,
    pivotAxisStyle(yLinearSecondary),
    colorAdapter(color, linearColor),
    backgroundColor,
    verticalCrosshairRect,
    annotationPointOfDualAxis,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationAreaBand,

    tooltipDualAxis,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const dualAxisSpecPipeline = [pivotAdapter(dualAxis, pivotDualAxis)]
